import HTTP from '@api';

import { generateXHRError } from '@helpers';

export default {
  async getStatistics({ suffix, startDate, endDate }) {
    try {
      const { data } = await HTTP.get(`${suffix}/statsbycategories`, {
        params: {
          startDate,
          endDate,
        },
      });
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(generateXHRError());
    }
  },

  async downloadCSV({ suffix, startDate, endDate }) {
    try {
      return await HTTP.get(`${suffix}/statsfinished`, {
        responseType: 'arraybuffer',
        params: {
          startDate,
          endDate,
        },
      });
    } catch (e) {
      return Promise.reject(generateXHRError());
    }
  },
};
